import { useEffect, useSyncExternalStore } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/shared/ui";
import {
  autoReloadForNewBuild,
  checkForNewBuild,
  isBuildStale,
  reloadNow,
  subscribeToStaleBuild,
} from "@/lib/app-version";
import { router } from "@/router";

export function AppVersionGate() {
  const stale = useSyncExternalStore(subscribeToStaleBuild, isBuildStale, () => false);

  // Un onglet périmé est par définition un onglet qu'on retrouve après des heures ou des jours :
  // le retour au premier plan est le bon moment pour vérifier.
  useEffect(() => {
    void checkForNewBuild();
    const check = () => {
      if (document.visibilityState === "visible") void checkForNewBuild();
    };
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    return () => {
      document.removeEventListener("visibilitychange", check);
      window.removeEventListener("focus", check);
    };
  }, []);

  // Recharger au prochain changement de route plutôt que sur-le-champ : rien de saisi n'est
  // perdu, et l'utilisateur ne voit qu'une navigation un peu plus lente.
  useEffect(() => {
    if (!stale) return;
    const from = window.location.pathname;
    return router.subscribe((state) => {
      if (state.location.pathname !== from) autoReloadForNewBuild();
    });
  }, [stale]);

  if (!stale) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-[9999] flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-4 rounded-2xl bg-[#003366] px-5 py-3 shadow-xl">
        <p className="text-xs font-bold text-white">Une nouvelle version est disponible</p>
        <Button variant="primary" size="sm" icon={RefreshCw} onClick={reloadNow}>
          Recharger
        </Button>
      </div>
    </div>
  );
}
